export default "__VITE_ASSET__DlwHXziL__"